import React, { useEffect } from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers"
import StackedBarChart from "components/ui/controls/stacked-bar-chart/StackedBarChart";

// Composant pour la légende du graphique empilé
const StackedLegend = ({ items }) => {
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e5e7eb",
        marginBottom: "20px",
        height: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <h4
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Légende
      </h4>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "8px 12px",
              borderRadius: "8px",
              backgroundColor: "#f9fafb",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "4px",
                backgroundColor: item.color,
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            ></div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const DetailIncapacite = ({ Outil, TabIJ, GraphIJ, Affichage }) => {
  useEffect(() => {
    document.getElementById("GraphIJ").innerHTML = GraphIJ;
  }, [GraphIJ]);

  const getIconStyle = () => {
    return { emoji: "💊", background: "linear-gradient(135deg, #374151 0%, #1f2937 100%)" };
  };

  const chartData = [
    { label: "Net perçu", obligatoire: 100, facultatif: 0, perteRevenu: 0 },
    ...TabIJ.map((data) => {
      const obligatoire = Math.max(0, data["TauxRempIJObligatoire"]);
      const facultatif = Math.max(0, data["TauxRempIJFacultatif"]);
      const perteRevenu = Math.max(0, 100 - obligatoire - facultatif);
      return {
        label: `De ${data.category.replace("-", " à ")} jours`,
        obligatoire,
        facultatif,
        perteRevenu,
      };
    }),
  ];

  const chartColors = ["#3b82f6", "#10b981", "#9ca3af"];

  const legendItems = [
    { label: "Régime obligatoire", color: chartColors[0] },
    { label: "Régime facultatif", color: chartColors[1] },
    { label: "Perte de revenu", color: chartColors[2] },
  ];

  return (
    <Column fill>
      <CardBox>
        
        <Column fill>
          <Row bpad>
            <div className="cotisations-container">
              <div className="cotisations-list-container">
                <div className="cotisations-header">
                  <div className="header-column"></div>
                  <div className="header-column"></div>
                  <div className="header-column">Régime(s) obligatoire(s)</div>
                  <div className="header-column">Régime(s) facultatif(s)</div>
                  <div className="header-column">Total</div>
                </div>
                {TabIJ.map((data, i) => {
                  const iconStyle = getIconStyle(data.category);

                  return (
                    <div key={i} className="cotisations-card">
                      <div className="cotisations-card-icon" style={{ background: iconStyle.background }}>
                        {iconStyle.emoji}
                      </div>
                      <div className="card-column">De {data.category.replace("-", " à ")} jours</div>
                      <div className="card-column">{applyFormat(Math.max(0, data["Régime obligatoire"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">{applyFormat(Math.max(0, data["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">{applyFormat(Math.max(0, data.Total), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Row>
          <Row style={{ gap: "20px", alignItems: "flex-start", marginTop: "20px" }}>
            <Column style={{ flex: 2 }}>
              <div style={{ position: "relative" }}>
                <StackedBarChart title="Prestations d'incapacité par période" data={chartData} colors={chartColors} variant="tube" referenceValue={100} />
                <div id="GraphIJ" style={{ display: "none" }}></div>
              </div>
            </Column>

            <Column style={{ flex: 1 }}>
              <StackedLegend items={legendItems} />
            </Column>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailIncapacite;
